import React from "react";
import "../../styles/Button.css";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outline" | "label" | "danger";
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      variant = "primary",
      iconLeft,
      iconRight,
      className = "",
      ...rest
    },
    ref
  ) => (
    <button
      ref={ref}
      className={`custom-btn ${variant} ${className}`}
      {...rest}
    >
      {iconLeft && <span className="btn-icon left">{iconLeft}</span>}
      {children}
      {iconRight && <span className="btn-icon right">{iconRight}</span>}
    </button>
  )
);

Button.displayName = "Button";

export default Button;
